__turbopack_context__.v({
  "arrow": "flat-module-sass-module__OkG9pW__arrow",
  "footer": "flat-module-sass-module__OkG9pW__footer",
  "footerSite": "flat-module-sass-module__OkG9pW__footerSite",
  "item": "flat-module-sass-module__OkG9pW__item",
  "licenseLogo": "flat-module-sass-module__OkG9pW__licenseLogo",
  "logo": "flat-module-sass-module__OkG9pW__logo",
  "opened": "flat-module-sass-module__OkG9pW__opened",
  "txt": "flat-module-sass-module__OkG9pW__txt",
  "version": "flat-module-sass-module__OkG9pW__version",
});
